export const percentageToPixels = (percentage:string, total: number) => {

    if (typeof percentage === 'string') {
        const numericValue = parseFloat(percentage);

        const pixelValue = (numericValue / 100) * total;

        return pixelValue;

    } else {
        throw new Error('El valor proporcionado no es un porcentaje válido.');
    }
}